export default __webpack_public_path__ + "static/media/ff_de.46cc9cb0.png";